var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"title__title"},[_vm._v(_vm._s(_vm.title[0])+" "),_c('br'),_vm._v(_vm._s(_vm.title[1]))]),_c('div',{staticClass:"title__subtitle"},[_vm._v(_vm._s(_vm.subtitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }